// This is a modal for Signupreferrerindiviualthree

import styled from "@emotion/styled";

export default function ModalAdminAddError({ onClose }) {
  return (
    <RootWrapperModalSignupreferrerindiviualthree>
      <Overlay>
        <Wrapper>
          <PopupMessages>
            <Left>
              <Frame1391>
                <OwlConfused />
                <OopsAccountAlreadyRegistered>
                  Oops, account already registered!
                </OopsAccountAlreadyRegistered>
                <ItLooksLikeAnAccountWithThisEmailUserEmailAlreadyExistsTryLoggingInInstead>
                  It looks like an account with this email already exists.
                </ItLooksLikeAnAccountWithThisEmailUserEmailAlreadyExistsTryLoggingInInstead>
                <Frame1400></Frame1400>
              </Frame1391>
            </Left>
          </PopupMessages>
        </Wrapper>
      </Overlay>
    </RootWrapperModalSignupreferrerindiviualthree>
  );
}

const RootWrapperModalSignupreferrerindiviualthree = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;



const PopupMessages = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 912px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 912px;
  box-sizing: border-box;
  padding: 24px 0px;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const OwlConfused = styled.div`
  width: 174px;
  height: 174px;
  background: url(https://d3nakrlcog1u3z.cloudfront.net/1751653037027-cbafa21a4146f19f102fb8d244ec20c0a1680ab9.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const OopsAccountAlreadyRegistered = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const ItLooksLikeAnAccountWithThisEmailUserEmailAlreadyExistsTryLoggingInInstead = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1400 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-sizing: border-box;
`;


